import React from "react";
import WinsAutosLogo from "../../components/WinsAutosLogo";
import ProgressBar from "./ProgressBar";
import { PROGRESS_MODE } from "../progressMode";
import "../styles/loading.css";

export default function FullPageLoader({
  message,
  submessage,
  mode = PROGRESS_MODE.INDETERMINATE,
  percent = null,
  progressLabel = "",
}) {
  return (
    <div className="gl-fullpage" role="status" aria-live="polite" aria-busy="true">
      <div className="gl-fullpage-card">
        <div className="gl-fullpage-logo">
          <WinsAutosLogo size={72} />
        </div>
        <div className="gl-spinner" aria-hidden />
        <ProgressBar mode={mode} percent={percent} label={progressLabel} size="lg" />
        <div className="gl-message">{message}</div>
        {submessage && <div className="gl-submessage">{submessage}</div>}
      </div>
    </div>
  );
}
